//====================================================
//  Function: Reviews
//====================================================
function componentAddHomeProducts() {
  if ($(".in-index").length) {
    var homeProductsTemplate = `
			<div class="section section-home-products">
		<div class="container">
			<div class="row tabs-group js-tabs-group">
				<div class="col-12">
						<div class="tabs-content js-tabs-content home-products" id="home-products">
							<div class="tab-content__item js-tab-content-item js-tab-content-item-all is-active" data-id="${homeMoreAll}">
							</div>
						</div>
						<div class="txt-c margin-top-2 margin-bottom-4">
							<a href="/${homeMoreAll}/" class="btn btn--black-outline btn--black-outline--ext btn--min-width-medium">${showAll}</a>
						</div>
				</div>
			</div>
			<div class="row txt-c">
				<div class="col-12">
					<div class="tags-group">
						<a href="/120-cm/" class="tag__item">120cm</a>
						<a href="/150-cm/" class="tag__item">150cm</a>
						<a href="/180-cm/" class="tag__item">180cm</a>
						<a href="/210-cm/" class="tag__item">210cm</a>
					</div>
				</div>
				<div class="col-12">
					<div class="tags-group">
						<a href="/2d-premium/" class="tag__item">2D Prémium</a>
						<a href="/${exclusiveLink}/" class="tag__item">${exclusive}</a>
						</div>
				</div>
			</div>
		</div>
	</div>
		`;

    $(homeProductsTemplate).insertBefore($(".zapati"));

    loadHomeProducts();

    setTimeout(() => {
      // initHomeChecker();
    }, 3000);

    // initHomeChecker();
  }
}

function loadHomeProducts() {
  $("#home-products .js-tab-content-item").each(function (index) {
    var inst = $(this);
    var categoryType = inst.data("id");
    index++;
    inst.load(
      window.location.protocol +
        "//" +
        window.location.host +
        "/" +
        categoryType +
        "/" +
        " #products .product:nth-child(-n+4)",
      function () {
        inst
          .find(".product")
          .wrapAll('<div class="products products-block"></div>');
        componentProductOne(inst);

        inst.find(".products .product").addClass("swiper-slide");
        inst.find(".products").addClass("swiper-wrapper");
        inst
          .find(".products")
          .wrap(
            '<div class="js-slider-group"><div class="swiper-container js-slider-products-home-' +
              index +
              '"></div></div>'
          );
        inst
          .find(".js-slider-products-home-" + index)
          .append(
            '<div class=" swiper-pagination swiper-pagination-hero js-swiper-paginations"></div>'
          );

        if ($(window).width() < 768) {
          productHomeSlider(index);
        }

        initHomeChecker();
        $("#home-products .product").each(function () {
          $(this)
            .find(".image img")
            .attr("src", $(this).find(".image img").attr("data-src"));
        });
      }
    );
  });
}

function initHomeChecker() {
  const breakpointHome = window.matchMedia("(min-width:768px)");
  const breakpointHomeChecker = function () {
    if (breakpointHome.matches === true) {
      if (mySwiperHomeProducts1 !== undefined)
        mySwiperHomeProducts1.destroy(true, true);
      // if (mySwiperHomeProducts2 !== undefined)
      //   mySwiperHomeProducts2.destroy(true, true);
      // if (mySwiperHomeProducts3 !== undefined)
      //   mySwiperHomeProducts3.destroy(true, true);
      // if (mySwiperHomeProducts4 !== undefined)
      //   mySwiperHomeProducts4.destroy(true, true);
      return;
    } else if (breakpointHome.matches === false) {
      // productHomeSlider(1);
      // productHomeSlider(2);
      // productHomeSlider(3);
      // productHomeSlider(4);
      return;
    }
  };
  breakpointHome.addListener(breakpointHomeChecker);
  breakpointHomeChecker();
}
